module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.idName
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._t("default", [_vm._v("\n\t\tDownload " + _vm._s(_vm.name) + "\n\t")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11bbffd0!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-json-excel/JsonExcel.vue
// module id = 1868
// module chunks = 1